const GlobalSearch = () => {
    const tabsNavi = document.querySelectorAll('.global-search__filter');
    const tabsContent = document.querySelectorAll('.global-search__results-group');

    tabsNavi.forEach( tab => {
        tab.addEventListener('click', () => {
            tabsNavi.forEach(navi => {
                navi.classList.remove('active');
            });
            tab.classList.add('active');
            var activeID = tab.dataset.filter;
            if(activeID) {
                tabsContent.forEach(tabContent => {
                    tabContent.classList.add('d-none');
                });
                var tabActive = document.querySelector('#' + activeID);
                tabActive.classList.remove('d-none');
            }else{
                tabsContent.forEach(tabContent => {
                    if(!tabContent.classList.contains('--noresults')){
                        tabContent.classList.remove('d-none');
                    }
                });
            }
            
        });
    });
}

export default GlobalSearch;